<template>
    <ifarmeImport :TestQuestion="TestQuestion" :preView="true"></ifarmeImport>
</template>
<script>
import ifarmeImport from '@/examinationViews/examHome/components/ifarmeImport'
export default {
    name: 'iframePrview',
    data(){
        return {
            TestQuestion: {}
        }
    },
    created(){
        let { code, questionId } = this.$route.query
        this.TestQuestion = JSON.parse(sessionStorage.getItem(`questionData${code}`)).find((item)=>item.questionId == questionId)
    },
    components:{
        ifarmeImport
    }
}
</script>
<style lang="scss" scoped>

</style>
